var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#861A1A",
    strokeWidth: 2,
    d: "M2.957 7.85c0-1.85.99-2 2.22-2h15.56c1.23 0 2.22.15 2.22 2 0 2.15-.99 2-2.22 2H5.177c-1.23 0-2.22.15-2.22-2Zm8-4.35c0-1.388.198-1.5.444-1.5h3.112c.246 0 .444.112.444 1.5 0 1.61-.198 1.498-.444 1.498h-3.112c-.246 0-.444.113-.444-1.499Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#861A1A",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M10.715 14v3.55M15.316 14v3.55M4.457 10l1.41 8.64c.32 1.94 1.09 3.36 3.95 3.36h6.03c3.11 0 3.57-1.36 3.93-3.24l1.68-8.76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFile);
export default __webpack_public_path__ + "static/media/deleteFile.67698f822ec0fc1de617517f437af07b.svg";
export { ForwardRef as ReactComponent };